import {RouteConfig} from "vue-router";
const AcpHome = () => import('../views/acp/AcpHome.vue');
const AcpUserList = () => import('../views/acp/AcpUserList.vue');
const AcpGroupList = () => import('../views/acp/AcpGroupList.vue');

let acp: RouteConfig[] = [
    {
        name: 'acp-home',
        path: '/acp/home',
        component: AcpHome,
    },
    {
        name: 'acp-users',
        path: '/acp/users/list',
        component: AcpUserList,
    },
    {
        name: 'acp-groups',
        path: '/acp/groups/list',
        component: AcpGroupList,
    },
];

export default acp;
